module.exports = __webpack_public_path__ + "png/4.png?5e19387ac063aa371b3dad5cfdcea4eb";